import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
// import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { CdkDragDrop, CdkDrag, CdkDropList, transferArrayItem, moveItemInArray} from '@angular/cdk/drag-drop';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ImportProductModalComponent } from '@teem/product-module/modals/import-product-modal/import-product-modal.component';
import { GoogleLocationModalComponent } from '@teem/store-module/modals/google-location-modal/google-location-modal.component';
import { AddProductsComponent } from '@teem/product-module/modals/add-products/add-products.component';
import { StoreInformationService } from '@teem/services/store-information.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { ProductService } from '@teem/services/product.service';
import { CategoryService } from '@teem/services/category.service';
import { EditProductComponent } from '@teem/product-module/modals/edit-product/edit-product.component';
import { ACTIONS as PRODUCT_ACTIONS } from '@teem/constants/product';

import { messages as i18n } from '@teem/constants/messages';
import { category as CategoryApi, country } from '@teem/constants/api';

import { country as CountryApi } from '@teem/core/constants/api';
import { fileNameFromUrl } from '@teem/helpers/functions';
import { CITY, SAUDI_ARABIA } from '@teem/core/constants/country';
import { STORE_TYPE } from '@teem/core/constants/defaults';
import { environment } from '@teem/environments/environment';
import { ExtraValidators } from '@teem/utils/ExtraValidators';
import { pad } from '@teem/helpers/functions';

declare var $: any;

@Component({
  selector: 'product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onConnectToFoodics: EventEmitter<any> = new EventEmitter();
  @Output() onDisconnectFoodics: EventEmitter<any> = new EventEmitter();
  @Output() onChangeProductListingType: EventEmitter<any> = new EventEmitter();
  @Input() foodicsDataFetched;
  @Input() productListingType;
  @Input() foodicsConnected;
  @Input() isAllowFoodicsSync;
  products: any;
  foodicsProducts: any;
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  selectKey: string = 'id';
  product: any = {};
  sortingProducts: any;
  
  constructor(
    private formBuilder: FormBuilder,
    private storeInformationService: StoreInformationService,
    private productService: ProductService,
    private categoryService: CategoryService,    
    private router: Router,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal
  ) {
    // this.createStoreFormGroup();
  }

  ngOnInit(): void {
    if (!this.foodicsDataFetched && this.productListingType == 'foodics') {
      this.loaderService.startLoading();
      this.storeInformationService.getFoodicsInfo().subscribe((data: any) => {
        this.loaderService.stopLoading();
        this.foodicsProducts = data;
      }, err => {
        this.loaderService.stopLoading();
        this.foodicsProducts = [];
        this.productListingType = null;
        this.onChangeProductListingType.emit(this.productListingType);
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    } else {
      this.loaderService.startLoading();
      this.productService.allProducts().subscribe((data: any) => {
        this.loaderService.stopLoading();
        this.products = data?.data;
        if (!this.foodicsConnected) {
          this.productListingType = 'manual';
          if (!this.products?.manual) {
            this.productListingType = null;
            this.onChangeProductListingType.emit(this.productListingType);
          } 
        }
        // this.foodicsConnected = true;
      }, err => {
        this.loaderService.stopLoading();
        this.foodicsProducts = [];
      });
    }
  }

  disconnectFoodics() {
    this.onDisconnectFoodics.emit();
  }

  getImageUrl(productUrl: string) {
    return productUrl ? productUrl : 'images/no-image.png';
  }

  // Final selected products
  finalSelected = [];

  // Check if category is fully selected
  isCategorySelected(category) {
    return category.products.every(product => this.finalSelected.some(p => p.id === product.id));
  }

  // Handle Category change
  onCategoryChange(event, category) {
    if (event.target.checked) {
      // Add all products from category to finalSelected
      category.products.forEach(product => {
        if (!this.finalSelected.some(p => p.id === product.id)) {
          this.finalSelected.push(product);
        }
      });
    } else {
      // Remove all products from category
      this.finalSelected = this.finalSelected.filter(product => !category.products.some(p => p.id === product.id));
    }

    // this.onSelect.emit(Object.values(this.finalSelected));
  }

  // Check if product is selected
  isProductSelected(product) {
    return this.finalSelected.some(p => p.id === product.id);
  }

  // Handle individual product selection
  onProductChange(event, category, product) {
    if (event.target.checked) {
      // Add product to finalSelected
      if (!this.finalSelected.some(p => p.id === product.id)) {
        this.finalSelected.push(product);
      }
    } else {
      // Remove product from finalSelected
      this.finalSelected = this.finalSelected.filter(p => p.id !== product.id);
    }

    // this.onSelect.emit(Object.values(this.finalSelected));
  }

  saveFoodicsInfo() {
    this.onSelect.emit(Object.values(this.finalSelected));
  }

	showHideActions(i, j) {
		const currentMenu = $('.options-menu-' + i + '-' + j);
		const isCurrentlyHidden = currentMenu.hasClass('d-none');
		$('.options-menu').addClass('d-none');

		if (isCurrentlyHidden) {
			currentMenu.removeClass('d-none');
		}
	}

  preventCollapse(event: MouseEvent) {
    event.stopPropagation(); // This prevents the parent div's click event from being triggered
  }

  collapseCategory(i) {
    $('.category_block-'+ i).toggleClass('collapsed');
    $('.category_body-'+ i).toggleClass('d-none');
  }

  editCategory(i) {
    let $input = $('.category_input_name-'+ i);
    $('.saveEdit').addClass('d-none');
    $('.category_input_name').prop('disabled', true);
    $('.category_input_name').css('border-color', 'transparent');
    $('.save-edit-' +i).removeClass('d-none');
    $input.prop('disabled', false).focus();
    $input.css('border-color', '#E0E0E0');
  }

  showHideCategory(category: any) {
    this.loaderService.startLoading();
    this.productService.action({'do': 'category-status-update', 'ids': [category.uuid]}).subscribe(category => {
      this.loaderService.stopLoading();
      this.ngOnInit();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openImportModal() {
    const modalRef = this.modalService.open(ImportProductModalComponent);
    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";
    modalRef.result.then(result => {
      this.ngOnInit();
    }, fallbackResult => {
      // do nothing
    })
  }

  showHideProduct(product: any, key: string, type: 'status-update' | 'stock-status') {
		this.productService.action({ 'do': type, 'ids': [product.uuid] }).subscribe(response => {
      console.log(response);
    }, err => {
      console.error(err);
    });
    
		product[key] = !product[key];
	}

  // showHideProduct(product: any) {
  //   this.loaderService.startLoading();
  //   this.productService.action({'do': 'status-update', 'ids': [product.uuid]}).subscribe((res: any)=> {
  //     this.loaderService.stopLoading();
  //     product.active = !product.active;
  //   }, err => {
  //     this.loaderService.stopLoading();
  //     product.active = product.active;
  //   })
  // }

  editProduct(product: any) {
    this.loaderService.startLoading();
    this.productService.get(product.uuid).subscribe(product => {
      this.product = product;
      this.openEditProductModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditProductModal() {
    let modalRef = this.modalService.open(EditProductComponent);
    modalRef.componentInstance.productInfo = this.product;

    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;
    parentElement.id = "add-product-service";
    parentElement.classList.add( "new-product-service");

    modalRef.result.then(
      onfulfilled => {
        this.ngOnInit();
      },
      onrejected => {

      }
    );
  }

  deleteProduct(product: any) {
    if(product.uuid) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.product.you_want_to_delete_product,
        // icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EB1461",
        confirmButtonText: i18n.delete,
        cancelButtonText: i18n.no_cancel_it,
        customClass: { cancelButton: 'custom_swal_cancel' }
      }).then( result => {
        if(result.value){
          this.loaderService.startLoading();
          this.productService.action({'do': PRODUCT_ACTIONS.DELETE, 'ids': [product.uuid]}).subscribe(data => {
            this.loaderService.stopLoading();
            this.ngOnInit();
            Swal.fire(i18n.deleted, i18n.product.deleted, 'success');
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }

  }

  changeProductListingType(type: string) {
    if (type == 'foodics')
      this.onConnectToFoodics.emit();
    else
      this.productListingType = type;
  }

  createNewCategory() {
    this.loaderService.startLoading();
    let fd;
    // fd.name = 'Category 1';
    this.productService.updateCreateCategory(fd).subscribe((res) => {
      this.loaderService.stopLoading();
      // this.products.manual[res.name].push([]);
      this.ngOnInit();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  updateCategory(category, categoryInput,categoryInputAr) {
    if (categoryInput) {
      let fd = category;
      fd.name = categoryInput;
      fd.name_ar = categoryInputAr ?? null;
      this.productService.updateCreateCategory(fd).subscribe((res) => {
        this.loaderService.stopLoading();
        $('.saveEdit').addClass('d-none');
        $('.category_input_name').prop('disabled', true);
        $('.category_input_name').css('border-color', 'transparent');
      }, err => {
        this.loaderService.stopLoading();
      })
    }
  }

  addNewProduct(category) {
    const modalRef = this.modalService.open(AddProductsComponent);
    modalRef.componentInstance.category = category;
    // const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;

    modalRef.result.then(result => {
      this.ngOnInit();
    }, fallbackResult => {
      // do nothing
    })
  }

  drop(event: CdkDragDrop<any[]>, listType: 'category' | 'product', categoryId?: number): void {
    this.sortingProducts = this.productListingType == 'foodics' ? this.products?.foodics : this.products?.manual;
    if (listType === 'category') {
      moveItemInArray(this.sortingProducts, event.previousIndex, event.currentIndex);
      const orderedIds = this.sortingProducts.map(c => c.category.id);
      this.productService.reorderCategory({ordered_ids: orderedIds}).subscribe((res) => {
        // this.loaderService.stopLoading();
      }, err => {
        // this.loaderService.stopLoading();
      })
    } else if (listType === 'product' && categoryId !== undefined) {
      const category = this.sortingProducts[categoryId];
      if (event.previousContainer === event.container) {
        moveItemInArray(category.products, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  dropProduct(event: CdkDragDrop<any[]>, category: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(category.products, event.previousIndex, event.currentIndex);
      const orderedIds = category.products.map(p => p.id);
      this.productService.reorderProduct({ordered_ids: orderedIds}).subscribe((res) => {
        // this.loaderService.stopLoading();
      }, err => {
        // this.loaderService.stopLoading();
      })
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    // this.updateProductOrder(category);
  }

}
